module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_8003.56803dfe.png";